import axios from "axios";

// const AuthStr = "Bearer " + localStorage.getItem("token");
function getAuthHeader() {
  if (window.isSharedReportMode === true) {
    const copied = localStorage.getItem("share_access_token_copied");
    const email = localStorage.getItem("share_access_token_email");
    const token = copied || email;

    if (!token) return "";
    return `Bearer ${token}`;
  }

  const userToken = localStorage.getItem("token");
  return userToken ? `Bearer ${userToken}` : "";
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY + url, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function getV2ApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY2 + url, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function postApiCall(url, body) {
    return axios
        .post(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone, },
        })
        .then((data) => {
            return data;
        });
}

function postApiCall2(url, body) {
    return axios
        .post(process.env.REACT_APP_API_KEY2 + url, body, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone, },
        })
        .then((data) => {
            return data;
        });
}

function putApiCall(url, body) {
    return axios
        .put(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function deleteApiCall(url, body) {
    return axios.delete(process.env.REACT_APP_API_KEY + url, {
        headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        data: body
    }).then((data) => {
        return data;
    });
}

/** A 403 that is an RBAC denial (e.g. FastAPI "You do not have permission: jobs.job.edit") must not end the session. */
const PERMISSION_DENIED_PATTERN = /permission/i;

// Several requests can fail with 401 at once (e.g. messenger loads inbox,
// unread summary and team inbox together); only the first one logs out.
let isLoggingOut = false;

function handle403Logout(error) {
  if (isLoggingOut) return;
  // getJobApiCall / getJobApiTextCall reject with { parsedStatus, originalError }
  const response = error?.response || error?.originalError?.response;
  const status = response?.status ?? error?.parsedStatus;
  const data = response?.data;
  const serverMessage =
    (typeof data?.detail === 'string' && data.detail) ||
    data?.message ||
    data?.responseMessages?.[0]?.message ||
    '';

  if (status === 403 && PERMISSION_DENIED_PATTERN.test(serverMessage)) {
    console.warn('Permission denied:', serverMessage);
    return;
  }

  const isSharedViewer = localStorage.getItem("share_access_token_copied") || localStorage.getItem("share_access_token_email");
  if (isSharedViewer && (status === 403 || status === 401)) {
    localStorage.removeItem("share_access_token_copied");
    localStorage.removeItem("share_access_token_email");
    localStorage.removeItem("share_access_token_expiry");
    window.dispatchEvent(new Event("shared-auth-expired"));
    return;
  }

  if (status === 403 || status === 401) {
    isLoggingOut = true;
    // Lets the shared messenger socket and chat components close cleanly
    window.dispatchEvent(new CustomEvent('APP_LOGOUT'));
    localStorage.clear();
    window.location.href = '/login';
  }
}

export { getApiCall, postApiCall, postApiCall2, putApiCall, deleteApiCall, getV2ApiCall, handle403Logout };
